import { cn } from '@/utils/styles';
import { Card } from '@design-system/Card';
import { Link } from '@design-system/Link';
import { List, ListItem } from '@design-system/List';
import { linkoutConfigs } from '@/config/routing/LinkoutConfig';

export type SettingsPagePoliciesSectionProps = React.ComponentProps<'div'> & {
  'data-testid'?: string;
};

export const SettingsPagePoliciesSection = ({
  className,
  'data-testid': testId,
}: SettingsPagePoliciesSectionProps) => {
  const policyLinks = [
    {
      label: 'Terms & Service',
      to: linkoutConfigs.terms,
    },
    {
      label: 'Privacy Policy',
      to: linkoutConfigs.privacy,
    },
    {
      label: 'Copyright Acknowledgement',
      to: linkoutConfigs.copyright,
    },
  ];

  return (
    <div className={cn('flex flex-col', className)} data-testid={testId}>
      <span className="typography-h2 text-primary mb-6" data-testid="settingsPolicies-title">Policies</span>
      
      <Card data-testid="settingsPolicies-card">
        <List data-testid="settingsPolicies-list">
          {policyLinks.map(({ label, to }) => {
            const itemTestId = `settingsPolicies-item-${label.toLowerCase().replace(/\s+/g, '').replace(/&/g, '')}`;
            return (
              <ListItem key={label} asChild data-testid={itemTestId}>
                <Link 
                  to={to}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {label}
                </Link>
              </ListItem>
            );
          })}
        </List>
      </Card>
    </div>
  );
};